import Site from '@/service/Site';

/**
 * @name app
 * @description Exposes menu store module
 */
export default {
	/**
	 * @method @static @get @name namespaced
	 * @description Is this module namespaced?
	 */
	namespaced: true,

	/**
	 * @method @static @get @name state
	 * @description Expose state as an object, compatible with vue stores
	 */
	state: {
		error: null,
		maxLtvs: null,
		averageLtvs: null,
		marketDataUpdatedDate: null
	},

	/**
	 * @method @static @get @name getters
	 * @description Expose getters as an object, compatible with vue stores
	 */
	getters: {},

	/**
	 * @method @static @get @name mutations
	 * @description Expose mutations as an object, compatible with vue stores
	 */
	mutations: {
		/**
		 * @method @static @get @name setMarketData
		 * @description Set maxLtvs config
		 * @param {Object} state The store state
		 * @param {Object} payload The payload to set
		 */
		setMarketData(state, payload) {
			state.maxLtvs = payload.ltv;
			state.averageLtvs = payload.ltvAverage;
			state.marketDataUpdatedDate = payload.updated;
		},

		/**
		 * @method @static @get @name setError
		 * @description Set error config
		 * @param {Object} state The store state
		 * @param {Object} payload The value to set
		 */
		setError(state, value) {
			state.error = value;
		}
	},

	/**
	 * @method @static @get @name actions
	 * @description Expose action as an object, compatible with vue stores
	 */
	actions: {
		/**
		 * @method @name getMarketData
		 * @description Get LTV rates
		 * @returns {Object} Promise a http response
		 * @param {Object} context The store context
		 */
		getMarketData({ commit }) {
			Site.getDbContent('market_data')
				.then(({ data }) => {
					commit('setMarketData', data);
				})
				.catch((error) => {
					commit('setError', error);
				});
		},

		/**
		 * @method @name getWhiteLabelConfig
		 * @description Get white label config
		 * @param {Object} context The store context
		 * @param {String} uuid The white label UUID
		 * @returns {Object} Promise a http response
		 */
		getWhiteLabelConfig({ commit }, uuid) {
			return Site.getWhiteLabelConfig(uuid)
				.then(({ data }) => {
					return data;
				})
				.catch((error) => {
					commit('setError', error);
					throw error;
				});
		}
	}
};
